import { z } from "zod";

import { MAX_LENGTH } from "@/components/ui/OTPInput/constants";

export const verifyEmailSchema = z.object({
  code: z.string().length(MAX_LENGTH, "Verification code must be 6 digits"),
});

export type VerifyEmailFormValues = z.infer<typeof verifyEmailSchema>;
